import React from 'react';
import { useForm } from 'react-hook-form';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import { LoginComponent } from 'components/App/AuthPublicPages/_common/LoginComponent/LoginComponent';
import { ILoginForm } from 'components/App/AuthPublicPages/Login/login';
import { useMutationGetUserDomain } from 'api/mutations/getUserDomain.mutation';
import { useMutationExternalLogin } from 'api/mutations/externalLogin.mutation';

export const ExternalRedirect = () => {
    const { handleSnackBar } = useCustomSnackBar();
    const { mutate: mutateGetUserDomain, isLoading: isLoadingGetUserDomain } = useMutationGetUserDomain();
    const { mutate: mutateExternalLogin, isLoading: isLoadingExternalLogin } = useMutationExternalLogin();
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
    } = useForm<ILoginForm>();
    const login = (data: ILoginForm) => {
        mutateGetUserDomain(
            { username: data.username },
            {
                onSuccess: (response) => {
                    if (response.domain) {
                        mutateExternalLogin(
                            { username: data.username, password: data.password, domain: response.domain },
                            {
                                onSuccess: (responseLogin) => {
                                    window.location.href = `https://${response.domain}/externalLogin?email=${data.username}&token=${responseLogin.accessToken}`;
                                },
                                onError: (error) => {
                                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                                },
                            },
                        );
                    }
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
            },
        );
    };

    return (
        <LoginComponent
            title={'Sign in'}
            handleSubmit={handleSubmit}
            login={login}
            errors={errors}
            register={register}
            control={control}
            error={undefined}
            isLoading={isLoadingGetUserDomain || isLoadingExternalLogin}
            enableSSO={false}
        />
    );
};
